
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ObjectTypeInfo, PageBase, T4RentalObjectService } from 't4core';
import { T4DatatableWidget } from '../../../../t4common';
import { CreateObjectTypeDialog } from '../../dialogs/CreateObjectTypeDialog/CreateObjectTypeDialog';
@Component({
  styleUrls: ['./ObjectTypes.css'],
  selector: 'ObjectTypes',
  templateUrl: './ObjectTypes.html',
})
export class ObjectTypesComponent extends PageBase implements OnInit {

    public myObjectTypes: ObjectTypeInfo[] = [];
    public inheritedObjectTypes: ObjectTypeInfo[] = [];

    @ViewChild("inherited")
    private inherited: T4DatatableWidget;

  constructor(el: ElementRef, private route: ActivatedRoute, private svcObject: T4RentalObjectService) {
      super(el, "Settings");
    }

    async ngOnInit() {
        this.getObjectTypes();
    }

    public async getObjectTypes() {
        var token = this.UI.beginLoading("T4.Settings.Addons.msgLoading", "Loading addons", null);
       
      this.myObjectTypes = await this.svcObject.GetMyTypes(0);
      var inheritedObjectTypes = await this.svcObject.GetAllTypes(0, false);
        var filteredInheritedObjectTypes: ObjectTypeInfo[] = [];
        for (let a of inheritedObjectTypes) {
            var overridden = inheritedObjectTypes.find(x => x.OverridesType == a.Id.toString());
            if (!overridden) {
                filteredInheritedObjectTypes.push(a);
            }
        }
        this.inheritedObjectTypes = filteredInheritedObjectTypes;

        this.UI.loaderCompleted(token);
    }

    public async openType(type: ObjectTypeInfo = null, editable: boolean = true) {
        var all = this.inheritedObjectTypes.concat(this.myObjectTypes);
        if (type) {
            var index = -1;
            for (let i = 0; i < all.length; i++) {
                if (all[i].Id == type.Id) index = i;
            }
            if (index > -1) all.splice(index, 1);
      }
        await this.Dialog.open(CreateObjectTypeDialog, { width: '850px', data: { allAddons: all, inheritedAddons: this.inheritedObjectTypes, addonToChange: type ? type : false, editable: editable } }).afterClosed().toPromise();
        this.getObjectTypes();
    }

    public async deleteType(type: ObjectTypeInfo) {

        var d = await this.UI.confirm("T4.Settings.Addons.titleConfirmDelete", "Confirm deletion", "T4.Settings.Addons.msgConfirmDelete", "Do you want to remove this addon?");

        if (d) {
            var deleted = await this.Api.delete<boolean>("RentalObject/DeleteAddon", { id: type.Id });
            if (deleted) {
                this.getObjectTypes();
            }
            else {
                alert("Error, could not be deleted");
            }
        }
    }

}
